enum RolesEnum {
    Admin = 1,
    Usuario = 5,
    CoordinadorCentro = 3,
    Docente = 4,
    ResponsableAlmacen = 5,
}

export default RolesEnum;